module.exports = __webpack_public_path__ + "static/img/6792_phase_function_Paper_PointsHejduk_Prediction.8a326bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6792_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ooD4
// module chunks = 0